import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { SharedModule } from "../shared/shared.module";

import { DialogService } from "../shared/services/dialog.service";

import { CareersModule } from "../careers/careers.module";
import { TrainingModule } from "../training/training.module";

import { StepsComponent } from "./steps/steps.component";
import { GuideComponent } from "./guide/guide.component";

import { PreAssessmentComponent } from "./steps/preassessment.component";
import { PostAssessmentComponent } from "./steps/postassessment.component";
import { ModuleSectionComponent } from "./guide/components/module-section.component";
import { ModuleSectionDirective } from "./guide/components/module-section.directive";
import { ModActivitiesComponent } from "./guide/components/mod-activities.component";
import { ActivityViewComponent } from "./guide/components/activity-view.component";
import { ConfirmModalComponent } from "./guide/components/confirm-modal.component";


import { NgCircleProgressModule } from "ng-circle-progress";
import { _1AComponent } from "./guide/components/group1/1A.component";
import { _1BComponent } from "./guide/components/group1/1B.component";
import { _1CComponent } from "./guide/components/group1/1C.component";
import { _2AComponent } from "./guide/components/group2/2A.component";
import { _2BComponent } from "./guide/components/group2/2B.component";
import { _3AComponent } from "./guide/components/group3/3A.component";
import { _3BComponent } from "./guide/components/group3/3B.component";
import { _3CComponent } from "./guide/components/group3/3C.component";

import { CanDeactivatePreAssessmentService } from "./services/candeactivate-preassessment.service";
import { CanDeactivatePostAssessmentService } from "./services/candeactivate-postassessment.service";
import { AuthGuard } from "../shared/services/AuthGuard.service";
import { LearningmodulesCompletedComponent } from './guide/components/learningmodules-completed.component';
import { IdentityComponent } from './identity.component';
import { RoleGuard } from "../shared/services/roleGuard.service";
//import { NoteEditModalComponent } from "../shared/components/notes/note-edit-modal.component";

@NgModule({
  imports: [
    SharedModule,
    CareersModule, TrainingModule,
    NgCircleProgressModule.forRoot(),
    RouterModule.forChild([
      { path: "employment101/guide/:moduleGroupId/:sectionId/:moduleId/:activityId/:complete", component: GuideComponent, canActivate: [], canDeactivate: [], data: { title: 'E101 Step' } },
      { path: "employment101/guide/:moduleGroupId/:sectionId/:moduleId/:activityId", component: GuideComponent, canActivate: [AuthGuard], canDeactivate: [], data: { title: 'E101 Step' } },
      { path: "employment101/guide/:moduleGroupId/:sectionId/:moduleId", component: GuideComponent, canActivate: [AuthGuard], canDeactivate: [], data: { title: 'E101 Step' } },
      { path: "employment101/guide/:moduleGroupId/:sectionId", component: GuideComponent, canActivate: [AuthGuard], canDeactivate: [], data: { title: 'E101 Step' } },
      { path: "employment101/guide/:moduleGroupId", component: GuideComponent, canActivate: [AuthGuard], canDeactivate: [], data: { title: 'E101 Step' } },
      { path: "employment101/guide", component: GuideComponent, canActivate: [AuthGuard], canDeactivate: [], data: { title: 'E101 Guide' } },
      { path: "employment101/preassessment", component: PreAssessmentComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivatePreAssessmentService], data: { title: 'E101 Pre Assessment' } },
      { path: "employment101/postassessment", component: PostAssessmentComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivatePostAssessmentService], data: { title: 'E101 Post Assessment' } },
      { path: "employment101/preassessment/:assessmentId/:type", component: PreAssessmentComponent, data: { title: 'E101 Assessment' } },
      { path: "employment101/postassessment/:assessmentId/:type", component: PostAssessmentComponent, data: { title: 'E101 Assessment' } },
      { path: "employment101/identity/:userguid/:step", component: IdentityComponent, canActivate: [AuthGuard, RoleGuard], canDeactivate: [], data: { title: 'E101 Userguide' } },
      { path: "employment101/identity/:userguid", component: IdentityComponent, canActivate: [AuthGuard, RoleGuard], canDeactivate: [], data: { title: 'E101 Userguide' } },
      { path: "employment101", component: StepsComponent, canActivate: [AuthGuard], canDeactivate: [], data: { title: 'E101' } },
      { path: "employment101/**", component: StepsComponent, canActivate: [AuthGuard], canDeactivate: [], data: { title: 'E101' } },
    ])
  ],
  declarations: [
    StepsComponent,
    GuideComponent,
    PreAssessmentComponent,
    PostAssessmentComponent,
    ModuleSectionComponent, ModuleSectionDirective, ModActivitiesComponent, ActivityViewComponent, ConfirmModalComponent,
    _1AComponent, _1BComponent, _1CComponent, _2AComponent, _2BComponent, _3AComponent, _3BComponent, _3CComponent, LearningmodulesCompletedComponent, IdentityComponent],
  exports: [
  ],
  entryComponents: [
    _1AComponent, _1BComponent, _1CComponent, _2AComponent, _2BComponent, _3AComponent, _3BComponent, _3CComponent,
    ConfirmModalComponent
  ],
  providers: [
    DialogService, CanDeactivatePreAssessmentService, CanDeactivatePostAssessmentService
  ]
})
export class Employment101Module { }
